import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a9b6fd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "button-group" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", {
      class: _normalizeClass(["button-group__list", {
        vertical: _ctx.direction === 'vertical',
        rounded: _ctx.rounded,
      }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
        return (_openBlock(), _createElementBlock("li", {
          class: _normalizeClass(["button", _ctx.getClasses(option)]),
          onClick: ($event: any) => (_ctx.select(option))
        }, [
          _renderSlot(_ctx.$slots, "default", { option: option }, undefined, true)
        ], 10, _hoisted_2))
      }), 256))
    ], 2)
  ]))
}